import jquery from 'jquery'

// This is needed by i.a. netflexapp
window.$ = window.jQuery = window.jquery = jquery
